import { render, staticRenderFns } from "./ItemDocuments.vue?vue&type=template&id=7ddf987e&scoped=true"
import script from "./ItemDocuments.vue?vue&type=script&lang=js"
export * from "./ItemDocuments.vue?vue&type=script&lang=js"
import style0 from "./ItemDocuments.vue?vue&type=style&index=0&id=7ddf987e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf987e",
  null
  
)

export default component.exports